// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__zEyxn","mainContent":"MainLayout_mainContent__lk1IV"};